import {
  SET_AVAILABILITY_PAGE_LOADING,
  SET_AVAILABILITY_PAGE_ERROR,
  CLEAR_AVAILABILITY_LIST,
  GET_AVAILABILITY_LIST,
  GET_AVAILABILITY_LIST_SUCCESS,
  GET_AVAILABILITY_LIST_RESET_SUCCESS,
  GET_AVAILABILITY_LIST_ERROR,
  GET_VISIT_TYPES_SORT_OPTIONS_COLLECTION,
  GET_VISIT_TYPES_SORT_OPTIONS_COLLECTION_SUCCESS,
  GET_VISIT_TYPES_SORT_OPTIONS_COLLECTION_ERROR,
} from '../../store/availability/AvailabilityConstants'
import {
  SET_CALENDAR_OFFSET_BEFORE_NEW_VISIT,
  SET_CALENDAR_RANGE_BEFORE_NEW_VISIT,
} from '../../store/calendar/CalendarConstants'

export const availabilitiesPageBlackList = [
  SET_AVAILABILITY_PAGE_LOADING,
  SET_AVAILABILITY_PAGE_ERROR,
  CLEAR_AVAILABILITY_LIST,
  GET_AVAILABILITY_LIST,
  GET_AVAILABILITY_LIST_SUCCESS,
  GET_AVAILABILITY_LIST_RESET_SUCCESS,
  GET_AVAILABILITY_LIST_ERROR,
  GET_VISIT_TYPES_SORT_OPTIONS_COLLECTION,
  GET_VISIT_TYPES_SORT_OPTIONS_COLLECTION_SUCCESS,
  GET_VISIT_TYPES_SORT_OPTIONS_COLLECTION_ERROR,
  SET_CALENDAR_OFFSET_BEFORE_NEW_VISIT,
  SET_CALENDAR_RANGE_BEFORE_NEW_VISIT,
]
